import MenteeStatusChip from 'components/Chips/MenteeStatusChip';
import getFilters from 'components/Filters';
import MENTEE_STATUS, { MenteeStatusValues } from 'enums/MenteeStatus';
import MENTORSHIP_STATUS, {
  MentorshipStatusValues,
} from 'enums/MentorshipStatus';
import { FC, useContext } from 'react';
import { getIsMenteeStatus, menteeAssociateTags } from 'utils/menteeTags';
import {
  completedFormationColumn,
  considerationColumn,
  expertiseFieldsColumn,
  formationMatchingProjectColumn,
  formationStateColumn,
  getCareerPlanColumn,
  getEntrepreneurshipColumn,
  getJobSearchColumn,
  getStudiesColumn,
  hobbyColumn,
  intendedDiplomaColumn,
  intendedFormationColumn,
  validatedDiplomaColumn,
  volunteerStateColumn,
} from 'utils/tagColumns';
import { AssociateContext, TagColumnNames } from '.';

const Filters = getFilters<TagColumnNames>();
const AssociateFilter: FC = () => {
  const { search, setSearch, tags, setTags, take, setTake } =
    useContext(AssociateContext);

  return (
    <Filters
      tagList={[
        {
          columnName: 'status',
          columnTitle: 'Statut du mentorat',
          tags: menteeAssociateTags.map((tag) => {
            const isMenteeStatus = getIsMenteeStatus(tag);
            return {
              name: tag,
              label: isMenteeStatus
                ? MENTEE_STATUS[tag]
                : MENTORSHIP_STATUS[tag],
              labelComponent: (
                <MenteeStatusChip
                  status={
                    isMenteeStatus
                      ? (tag as MenteeStatusValues)
                      : 'MENTORSHIP_ACTIVE'
                  }
                  mentorshipStatus={
                    isMenteeStatus ? 'ONGOING' : (tag as MentorshipStatusValues)
                  }
                />
              ),
            };
          }),
        },
        getJobSearchColumn('mentee'),
        getCareerPlanColumn('mentee'),
        getStudiesColumn('mentee'),
        getEntrepreneurshipColumn('mentee'),
        expertiseFieldsColumn,
        completedFormationColumn,
        validatedDiplomaColumn,
        formationMatchingProjectColumn,
        formationStateColumn,
        intendedFormationColumn,
        intendedDiplomaColumn,
        considerationColumn,
        hobbyColumn,
        volunteerStateColumn,
      ]}
      state={{ tags, search, take }}
      setTags={setTags}
      setSearch={setSearch}
      setTake={setTake}
    />
  );
};

export default AssociateFilter;
